function FeedPostBackText({
  text,
  className
}: {
  text: string
  className?: string
}) {
  return (
    <div
      className={`${className} text-base prose word-break`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: text }}
    />
  )
}

export default FeedPostBackText
